<template>
  <div class="bg-gray-800 text-white">
    <div class="container mx-auto px-4 pt-4 pb-8">
      <div class="flex flex-col sm:flex-row">
        <div class="w-full sm:w-1/2 flex flex-col justify-center items-center">
          <div class="w-2/3 mx-auto">
            <h1>About Jing</h1>
            <p>
              Jing is a web developer who has a lot of creativity. She
              specializes in building interactive story-telling websites. She'd
              love to bring you bespoke and unique websites.
            </p>
          </div>
        </div>
        <img
          class="object-contain"
          alt="hero illustrate"
          src="../assets/hero-illustrate.png"
          width="700"
          height="700"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeroBanner",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.hero-img {
  max-width: 100%;
  height: auto;
}

@media (max-width: 640px) {
  .hero-img {
    width: 50%;
    margin: auto;
  }
}
</style>
